import { RoutablePage, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { notificationService, NotificationStyle } from '@gig/magic-messaging';

var AccountClosureFormComponent = /** @class */ (function (_super) {
    __extends(AccountClosureFormComponent, _super);
    function AccountClosureFormComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AccountClosureFormComponent.prototype, "closeAccountParams", {
        get: function () {
            return {
                reason: 'account closure',
                externalResource: 'user-profile',
            };
        },
        enumerable: false,
        configurable: true
    });
    AccountClosureFormComponent.prototype.closeAccount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, magic.methods.users.closeAccountCorex(this.closeAccountParams)];
                    case 1:
                        _a.sent();
                        this.routeTo({
                            route: RoutablePage.ACCOUNT_CLOSURE_SUCCESS,
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        notificationService.show(this.$t('error.generic'), {
                            style: NotificationStyle.ERROR,
                            uniqueID: 'form-error-generic',
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AccountClosureFormComponent = __decorate([
        Component({
            name: 'corex-account-closure-form',
        })
    ], AccountClosureFormComponent);
    return AccountClosureFormComponent;
}(Mixins(MagicConfigMixin)));

export default AccountClosureFormComponent;
